import React, { Component } from 'react';
import { Col } from 'react-grid-system';

import { Select } from 'components/input';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

export default class UserDetailSelect extends Component {
  static propTypes = {
    label: PropTypes.string,
    value: PropTypes.object,
    placeholder: PropTypes.string,
    options: PropTypes.object,
    onChange: PropTypes.func
  };

  render() {
    const { label, value, placeholder, options, onChange } = this.props;

    return (
      <Col xs={12} sm={3}>
        <label className="class__select__label">
          <I18n html label={label} />
        </label>
        <Select
          name="class"
          value={value}
          placeholder={placeholder}
          options={options}
          onChange={onChange}
          isClearable={false}
        />
      </Col>
    );
  }
}
